import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateNationalId from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError } from '../../data/actions';

const NationalIdField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const {
    name,           // expected: "national_id"
    handleChange,
    handleErrorChange,
  } = props;

  const handleOnBlur = (event) => {
    const { value: ni } = event.target;

    // Validator returns ''/null when OK,
    // or an error string when invalid.
    const fieldError = validateNationalId(ni, formatMessage);

    handleErrorChange(name, fieldError || '');
  };

  const handleOnFocus = () => {
    // Clear frontend + backend error like UsernameField does.
    handleErrorChange(name, '');
    dispatch(clearRegistrationBackendError(name));
  };

  const handleOnChange = (event) => {
    const raw = event.target.value ?? '';

    // Keep digits only, cap to 14
    // (Egyptian National ID length).
    const digits = raw.replace(/\D/g, '').slice(0, 14);

    // Emit the same event shape the existing reducers expect.
    if (digits !== raw) {
      handleChange({
        target: {
          name,
          value: digits,
        },
      });
    } else {
      handleChange(event);
    }
  };

  return (
    <FormGroup
      {...props}
      handleChange={handleOnChange}
      handleFocus={handleOnFocus}
      handleBlur={handleOnBlur}
      helpText={[
        'Optional. Egyptian users only — enter your 14-digit National ID if applicable.',
      ]}
    />
  );
};

NationalIdField.defaultProps = {
  errorMessage: '',
  autoComplete: null,
};

NationalIdField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
};

export default NationalIdField;